import logo from '../logo.svg';
import '../App.css';

export default function Projects() {
  //var params = new URLSearchParams(window.location.search);
  //var number = params.get('factorme');
  
  return (
    <div className="App">
      <header className="App-header">
        <h1>Enjoy Learning Chess!</h1>
        <h2>Chess lesson content, coming soon.</h2>
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    </div>
  );
}



//export default App;
